import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-gray-200 sticky top-0 z-50">
      <nav className="mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/89ce65a415860e3da90921dded83bf21/b7b50e3cd2850e25481d88c22295b109.png" 
              alt="BC Robotics" 
              className="h-8 w-auto"
            />
            <div className="hidden md:block ml-3 text-sm text-gray-600">
              by BrainCommerce
            </div>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <a href="#solutions" className="text-gray-700 hover:text-blue-600 cursor-pointer transition-colors">Solutions</a>
            <a href="#industries" className="text-gray-700 hover:text-blue-600 cursor-pointer transition-colors">Industries</a>
            <a href="#case-studies" className="text-gray-700 hover:text-blue-600 cursor-pointer transition-colors">Case Studies</a>
            <a href="#about" className="text-gray-700 hover:text-blue-600 cursor-pointer transition-colors">About</a>
            <Button size="sm" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
              Request Demo
            </Button>
          </div>

          <button
            className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <a href="#solutions" className="text-gray-700 hover:text-blue-600 cursor-pointer transition-colors">Solutions</a>
              <a href="#industries" className="text-gray-700 hover:text-blue-600 cursor-pointer transition-colors">Industries</a>
              <a href="#case-studies" className="text-gray-700 hover:text-blue-600 cursor-pointer transition-colors">Case Studies</a>
              <a href="#about" className="text-gray-700 hover:text-blue-600 cursor-pointer transition-colors">About</a>
              <Button size="sm" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
                Request Demo
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
